// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSessionId } from './FoodSession';
import { testTemplateId } from './TestTemplate';
import { z } from 'zod';
export const foodSessionTestPlanId = (z.number());
export const foodSessionTestPlan = z.object({
    id: foodSessionTestPlanId,
    session_id: foodSessionId,
    test_template_id: testTemplateId,
    display_order: z.number(),
    created_at: z.date(),
});
export const foodSessionTestPlanInitializer = z.object({
    id: foodSessionTestPlanId.optional(),
    session_id: foodSessionId,
    test_template_id: testTemplateId,
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
export const foodSessionTestPlanMutator = z.object({
    id: foodSessionTestPlanId.optional(),
    session_id: foodSessionId.optional(),
    test_template_id: testTemplateId.optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FoodSessionTestPlan.js.map